exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-63f86ca8] .el-scrollbar__bar{opacity:1}\n", ""]);

// exports
